import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardHeader,
  Collapse
} from "reactstrap";

import classnames from "classnames";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useProfile } from "../../../Components/Hooks/UserHooks";
import { getProjectById as onGetProjectDetails } from "../../../slices/thunks"; // Assuming a similar action for projects

// Import moment for date formatting
import moment from "moment";

const ProjectDetails = () => {
  const { id } = useParams(); // Get the ID from the URL
  const dispatch = useDispatch();
  const [project, setProject] = useState(null);
  const [col1, setcol1] = useState(true);
  const [col2, setcol2] = useState(true);
  const [col3, setcol3] = useState(true);

  // Fetch the project details using the ID
  useEffect(() => {
    if (id) {
      dispatch(onGetProjectDetails(id)) // Dispatch the action to fetch the project details
        .unwrap() // Ensure we handle the promise resolution correctly
        .then((data) => {
          setProject(data);
        })
        .catch((error) => {
          console.error("Failed to fetch project details:", error);
        });
    }
  }, [id, dispatch]);

  // Format the date using moment.js
  const formatDate = (date) => {
    return moment(date).format("DD MMM YYYY"); // Format to "Day Month Year"
  };

  const formatTime = (time) => {
    return moment(time).format("h:mm A"); // Format to 12-hour format with AM/PM
  };

  function togglecol1() {
    setcol1(!col1);
  }

  function togglecol2() {
    setcol2(!col2);
  }

  function togglecol3() {
    setcol3(!col3);
  }

  return (
    <div className="page-content">
      <Container fluid>
        {/* <BreadCrumb title="Project Details" pageTitle="Projects" /> */}

        <Row>
          {/* Main Project Info */}
          <Col >
            <Card>
              <CardHeader>
                <div className="d-flex align-items-center">
                  <h5 className="card-title flex-grow-1 mb-0">
                    Project #{project?.id || "N/A"}
                  </h5>
                  {/* <div className="flex-shrink-0">
                    <Link
                      to="/projects-invoice-details"
                      className="btn btn-success btn-sm"
                    >
                      <i className="ri-download-2-fill align-middle me-1"></i>{" "}
                      Invoice
                    </Link>
                  </div> */}
                </div>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md={6}>
                    <div className="d-flex mb-3">
                      <strong>Project Name:</strong>
                      <p className="ms-3">{project?.name || "N/A"}</p>
                    </div>
                    <div className="d-flex mb-3">
                      <strong>Starting Date:</strong>
                      <p className="ms-3">
                        {project?.starting_date
                          ? formatDate(project?.starting_date)
                          : "N/A"}
                      </p>
                    </div>
                    <div className="d-flex mb-3">
                      <strong>Estimated Finish Date:</strong>
                      <p className="ms-3">
                        {project?.estimated_finish_date
                          ? formatDate(project?.estimated_finish_date)
                          : "N/A"}
                      </p>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="d-flex mb-3">
                      <strong>Actual Finish Date:</strong>
                      <p className="ms-3">
                        {project?.actual_finish_date
                          ? formatDate(project?.actual_finish_date)
                          : "Not Finished"}
                      </p>
                    </div>
                    <div className="d-flex mb-3">
                      <strong>Status:</strong>
                      <p className="ms-3">{project?.active ? "Active" : "Inactive"}</p>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* Project Timeline */}
            <Card>
              <CardHeader>
                <div className="d-sm-flex align-items-center">
                  <h5 className="card-title flex-grow-1 mb-0">Project Status</h5>
                </div>
              </CardHeader>
              <CardBody>
                <div className="profile-timeline">
                  <div className="accordion accordion-flush" id="accordionFlushExample">
                    <div className="accordion-item border-0" onClick={togglecol1}>
                      <div className="accordion-header" id="headingOne">
                        <Link
                          to="#"
                          className={classnames("accordion-button", "p-2", "shadow-none", { collapsed: !col1 })}
                        >
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 avatar-xs">
                              <div className="avatar-title bg-success rounded-circle">
                                <i className="ri-shopping-bag-line"></i>
                              </div>
                            </div>
                            <div className="flex-grow-1 ms-3">
                              <h6 className="fs-15 mb-0 fw-semibold">
                                Project Started -{" "}
                                <span className="fw-normal">
                                  {project?.starting_date ? formatDate(project?.starting_date) : "N/A"}
                                </span>
                              </h6>
                            </div>
                          </div>
                        </Link>
                      </div>
                      <Collapse id="collapseOne" className="accordion-collapse" isOpen={col1}>
                        <div className="accordion-body ms-2 ps-5 pt-0">
                          <h6 className="mb-1">Project has started.</h6>
                          <p className="text-muted">{project?.starting_date}</p>
                        </div>
                      </Collapse>
                    </div>

                    {/* Add more collapsible items as needed */}
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProjectDetails;
